import { Location } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { NazioneItem, OrganizationOperatorItem, ProvinciaItem, UserOperatorItem } from 'src/app/models/dataModels';
import { APIService } from 'src/app/services/APIService';
import { AuctionService } from 'src/app/services/auction.service';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { LocalUtilService } from 'src/app/services/local-util.service';
import { MessagesService } from 'src/app/services/messages.service';
import { OrganizationService } from 'src/app/services/organization.service';

@Component({
    selector: 'app-elenco-operatori-full',
    templateUrl: './elenco-operatori-full.component.html',
    styleUrls: ['./elenco-operatori-full.component.css'],
    standalone: false
})
export class ElencoOperatoriFullComponent extends APIService implements OnInit, OnDestroy {

  @Input() operators: OrganizationOperatorItem[] = [];
  nation_list: NazioneItem[] = [];
  province_list: ProvinciaItem[] = [];
  private subscriptions: Subscription[] = [];

  constructor(public localService: LocalUtilService,
    public authService: AuthService,
    public auctionService: AuctionService,
    public organizationService: OrganizationService,
    public commonService: CommonService,
    private modalService: NgbModal,
    private messageService: MessagesService,
    location: Location, 
    router: Router, translateService: TranslateService) {
    super(localService, location, router, translateService);

  }

  ngOnInit(): void {
    this.loadNazioni();
    this.loadProvince();
  }

  loadNazioni() {
    const service = this.commonService.getNationsList().subscribe(
        data => {
          let nazioneVuota = new NazioneItem();
          nazioneVuota.codice="";
          nazioneVuota.descrizione=" - ";          
          this.nation_list.push(nazioneVuota);
          this.nation_list.push.apply(this.nation_list, data.list);
      },
        this.handleError(true)
      );
      this.subscriptions.push(service);
  }

  loadProvince() {
    this.province_list = [];
    const service = this.commonService.getProvinceItalianeList().subscribe(
        data => {
          let provinciaVuota = new ProvinciaItem();
          provinciaVuota.codice="";
          provinciaVuota.descrizione=" - ";          
          this.province_list.push(provinciaVuota);
          this.province_list.push.apply(this.province_list, data.list);
      },
        this.handleError(true)
      );
      this.subscriptions.push(service);
    }

    getOperatorStatusClass(itemOp:UserOperatorItem) {
      let output = '';
      if (itemOp.disabled == "Y") {
        output = "disabled";
        itemOp.status = "Disabilitato";
      } else if (itemOp.validated == "") {
        output = "pending";
        itemOp.status = "In attesa di verifica";
      } else if (itemOp.validated == "N") {
        output = "disabled";
        itemOp.status = "Rifiutato";
      } else if (itemOp.validated == "Y") {
        output = "active";
        itemOp.status = "Attivo";
      }
      return output;
    }
  
    getOperatorStatus(itemOp:UserOperatorItem) {
      let output = '';
      if (itemOp.disabled == "Y") {
        output = "Disabilitato";
      } else if (itemOp.validated == "") {
        output = "In attesa di verifica";
      } else if (itemOp.validated == "N") {
        output = "Rifiutato";
      } else if (itemOp.validated == "Y") {
        output = "Attivo";
      }
      return output;
    }

    onRowPrepared(info) {
      if (info.rowType === 'data') {
        info.rowElement.addClass('auction');
      }
    }

    ngOnDestroy() {
      try {
        this.subscriptions.forEach(sub => {
                  
          sub.unsubscribe()
        });
      } catch (err) {
        //
      }
    }

}
